export default __webpack_public_path__ + "assets/courier-promotion1-phone.png";